(() => {
  'use strict';

  const initFooter = footer => {
    if (!footer || footer.dataset.seqFooterReady === 'true') return;
    footer.dataset.seqFooterReady = 'true';

    const groups = Array.from(footer.querySelectorAll('[data-footer-group]'));
    const mobileQuery = window.matchMedia('(max-width: 640px)');

    const setGroupState = (group, open) => {
      const toggle = group.querySelector('[data-footer-toggle]');
      const content = group.querySelector('[data-footer-content]');

      group.classList.toggle('is-open', open);
      toggle?.setAttribute('aria-expanded', String(open));

      if (content) {
        if (mobileQuery.matches) {
          content.setAttribute('aria-hidden', String(!open));
        } else {
          content.removeAttribute('aria-hidden');
        }
      }
    };

    const syncLayout = () => {
      groups.forEach((group, index) => {
        setGroupState(group, mobileQuery.matches ? index === 0 : true);
      });
    };

    groups.forEach(group => {
      const toggle = group.querySelector('[data-footer-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        if (!mobileQuery.matches) return;

        const willOpen = !group.classList.contains('is-open');
        groups.forEach(otherGroup => setGroupState(otherGroup, false));
        setGroupState(group, willOpen);
      });
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncLayout);
    } else {
      mobileQuery.addListener(syncLayout);
    }

    syncLayout();
  };

  const initAll = root => {
    root.querySelectorAll?.('[data-seq-footer]').forEach(initFooter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
